import { render, staticRenderFns } from "./die-selection.vue?vue&type=template&id=76fa9faf&scoped=true&"
import script from "./die-selection.vue?vue&type=script&lang=js&"
export * from "./die-selection.vue?vue&type=script&lang=js&"
import style0 from "./die-selection.vue?vue&type=style&index=0&id=76fa9faf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fa9faf",
  null
  
)

export default component.exports